import {Component, Input, OnInit} from '@angular/core';
import {LayoutService} from '../home/layout.service';

@Component({
  selector: 'app-map-sidebar-tabs',
  templateUrl: './map-sidebar-tabs.component.html',
  styleUrls: ['./map-sidebar-tabs.component.scss']
})
export class MapSidebarTabsComponent implements OnInit {


  @Input()
  selectedIndex = 0;

  tabs = [
    {
      id: 0,
      text: 'Traceurs',
    },
    {
      id: 1,
      text: 'Parcelles',
    },
    {
      id: 2,
      text: 'Adresses',
    },
  ];


  constructor(private layoutService: LayoutService) {
  }

  ngOnInit(): void {
  }


  selectTab(e: any) {
    switch (e.itemData.id) {
      case 0:
        this.layoutService.focus('map-tractors');
        break;
      case 1:
        this.layoutService.focus('map-fields');
        break;
      case 2:
        this.layoutService.focus('map-poi');
        break;
    }
  }
}
